import { createFileRoute } from '@tanstack/react-router';

import { UserManagement } from '@apps/web/components/settings/user_management';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/team-members')({
    component: TeamMembersPage,
});

function TeamMembersPage() {
    const { organizationId } = useSettingsGates();
    if (organizationId === null) {
        return null;
    }
    return (
        <SettingsPageShell
            title="Team Members"
            description="Manage your team: invite new users, change roles and control access."
        >
            <UserManagement
                organizationId={organizationId}
                variant="embedded"
                showJoinedColumn={false}
            />
        </SettingsPageShell>
    );
}
